module.exports = __webpack_public_path__ + "static/img/battle_report.00bbff18.png";